import { GiHamburgerMenu } from "react-icons/gi";
import { useState } from "react";
import { NavUrls } from "../../utils/routes";
import { AnimatePresence, motion } from "framer-motion";
import { NavLink } from "./NavLink";
import { Button } from "./Button";
import { FaTimes } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { routeObj } from "../../constants/routes";

export default function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const router = useNavigate();
  const DropIn = {
    hidden: {
      opacity: 0,
    },
    visible: {
      y: "0",
      opacity: 1,
      transition: {
        duration: 0.75,
        ease: "easeInOut",
        // duration: 0.3,
        // type: "spring",
        // damping: 25,
        // stiffness: 500,
      },
    },
    exit: {
      opacity: 0,
    },
  };

  return (
    <div className=" ">
      <AnimatePresence initial={false} mode="wait" onExitComplete={() => null}>
        {isOpen && (
          <motion.div
            variants={DropIn}
            initial="hidden"
            animate="visible"
            exit="exit"
            className={`w-[100%]  top-0 right-0 left-0 py-4 fixed z-50 bg-secondary text-white h-fit flex md:hidden flex-col gap-6 justify-between items-center pb-10 px-10 text-[18px]`}
          >
            <FaTimes onClick={() => setIsOpen(!isOpen)} />
            {NavUrls?.map((item) => (
              <NavLink key={item.id} {...item} />
            ))}
            {/* <div className="w-[100%] text-center">
              <Link to={routeObj.login}>
                {" "}
                <div className="w-fit m-auto text-[15px]">Login</div>
              </Link>
              <Link to={routeObj.login}>
                <div className=" bg-primary rounded-lg text-sm text-white font-bold my-3 py-3 w-[90%] m-auto ">
                  Register
                </div>
              </Link>
            </div> */}
          </motion.div>
        )}
      </AnimatePresence>

      <div className="h-[80px] relative z-10 left-0 right-0 top-0 bg-mai">
        <div className="w-[100%] px-3  h-full  bg-hite flex justify-between items-center ">
          <img
            src="/img/logo.png"
            width={"150px"}
            alt="logo"
            loading="lazy"
            className=" cursor-pointer "
            onClick={() => router(routeObj.landing)}
          />
          <div className="w-[50%] text-main hidden  bg-green-00 text-[14px] font-   md:flex justify-between items-center ">
            {NavUrls?.map((item) => (
              <NavLink key={item.id} {...item} />
            ))}
          </div>
          <Button className=" hidden md:block bg-main px-6 py-3 rounded-full text-white text-sm mr  ">
            Fly With FlightPadi
          </Button>

          <Button
            id="menu"
            className=" py-2 px-3 md:hidden mr-4 text-white  border-2 border-main "
            onClick={() => setIsOpen(!isOpen)}
          >
            <GiHamburgerMenu
              className={` text-main ${isOpen ? "rotate-180" : ""}`}
              fill=""
            />
          </Button>
        </div>
      </div>
    </div>
  );
}
